export default {
  "Audio Compressor": "Аудиокомпрессор",
  "HitPaw Online Audio Compressor": "HitPaw Онлайн Аудио Компрессор",
  "Reduce audio file size online without quality loss.": "Уменьшите размер аудиофайла онлайн без потери качества.",
  "Compress": "Сжимать",
  "Compressing": "Сжатие",
  "Compressed Successfully": "Сжатие Успешно",
  "Compress New": "Сжатие Нового",
  "Compression is complete": "Сжатие завершено",
  "Compression failed": "Не удалось выполнить сжатие",
  "Quality": "Качество",
  "Format": "Формат",
  "Add file": "Добавить файл",
  "Output Settings": "Настройки вывода",

};
